/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Header from "../header/header.js"

import styles from './layout.module.scss'

import "./layout.css"

const Layout = (props) => (
  <>
    <Header showCTA={props.showCTA} useWhiteBg={props.useWhiteHeaderBg} />
    <main className={styles.mainRoot}>{props.children}</main>
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  showCTA: true,
  useWhiteHeaderBg: true,
}

export default Layout
